
  import ScreenSize from '@/mixins/ScreenSize';
  import Events from '@/events/Events';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    name: 'RegistrationSuccessPage',
    components: {
      CardWithImage: () => import('@/components/elements/CardWithImage'),
      RichText: () => import('@/components/elements/RichText'),
      DialogsBaseSection,
    },
    mixins: [ScreenSize],
    props: {
      matomoEventName: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        section: {},
        cardsLength: 0,
      };
    },
    async fetch() {
      this.section = await this.$cachedStrapi
        .find('registration-success-dialog')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
      this.cardsLength = this.section.cards.length;
    },
    computed: {
      imageUrl() {
        return this.section.image
          ? prepareImageUrl(this.section.image.url)
          : require(process.env.NUXT_ENV_FALLBACK_CARD_IMAGE);
      },
    },
    methods: {
      closeDialog() {
        this.$emit('close-dialog');
        this.$emitWithClientData(Events.ThankYouPageClosed, {
          type: this.matomoEventName,
        });
      },
      redirectToUserProfile() {
        this.$router.push(
          this.localePath({
            name: 'myData',
          })
        );
        this.$emitWithClientData(Events.ThankYouSwitchToProfileComplete, {
          type: this.matomoEventName,
        });
      },
    },
  };
